import React from 'react'
import PropTypes from 'prop-types'
import { Box, Link } from '@maui/elements'
import { useEodDrawer } from '../../../providers/EodDrawerContext'

export default function StepNavigator({ viewCurrentRequests = true, children }) {
  const { state, dispatch } = useEodDrawer()
  const { showCurrentRequests } = dispatch

  return (
    <Box
      display='flex'
      flexWrap='wrap'
      marginTop='-16px'
      marginLeft='-16px'
      marginRight='-16px'
      padding='spaceGapLarge'
      backgroundColor='colorFillDeemphasis'
    >
      { children }
      { viewCurrentRequests && (
        <Box flexBasis='100%' paddingTop='spaceGapLarge' textAlign='right'>
          <Link variant="primary" fontWeight="fontWeightBold" disabled={state.caseCount === 0} onClick={() => showCurrentRequests(true)}>
              View Current Requests ({state.caseCount || 0})
          </Link>

        </Box>
      )}
    </Box>
  )
}

StepNavigator.propTypes = {
  children: PropTypes.node.isRequired,
  viewCurrentRequests: PropTypes.bool,
}
